import React, { Component } from "react";
import { observer } from "mobx-react";
import { reaction } from "mobx";
import reportsStore from "../reportsStore";
import AnalyticsCard from "../sequence/AnalyticsCard";
import SequenceGraphComponent from "../sequence/SequenceGraphComponent";
import ReportsActivity from "../activity/ReportsActivity";
import CallsAnalyticsSection from "./CallsAnalyticsSection";
import dialerStoreData from "Stores/DialerData";

@observer
class ReportsCalls extends Component {
  disposeReaction = null;

  componentDidMount() {
    this.fetchData();
    
    this.disposeReaction = reaction(
        () => [reportsStore.dateFilter, reportsStore.memberIds],
        () => {
            this.fetchData();
        }
    );
  }

  componentWillUnmount() {
      if (this.disposeReaction) {
          this.disposeReaction();
      }
  }

  fetchData = () => {
    // Fetch the ideal data structure
    reportsStore.fetchCallsReportV2();
  }

  constructAnalyticsData = () => {
    const { callsReportData } = reportsStore;
    const { overview } = callsReportData || {};
    const { 
      totalCalls = 0, 
      loggedCalls = 0, 
      notLoggedCalls = 0
    } = overview || {};

    const dataArr = [
      {
        name: "Calls Made",
        count: totalCalls,
        color: "#3953FB"
      },
      {
        name: "Calls Logged",
        count: loggedCalls,
        color: "#00A358"
      },
      {
        name: "Calls Not Logged",
        count: notLoggedCalls,
        color: "#F59064"
      }
    ];

    const tempArr = [
      {
        cardName: "Calls Overview",
        cardCount: totalCalls,
        dataArr
      }
    ];
    return tempArr;
  };

  constructGraphCallsData = () => {
    const { callsReportData } = reportsStore;
    const { overview = {}, outcomes = {} } = callsReportData || {};
    const { answered = [], notAnswered = [] } = outcomes;
    const { totalTimeOnCall = "0s", avgCallDuration = "0s" } = overview || {};

    const graphs = [];

    // Always show Answered graph, even if empty
    const answeredTotal = answered.reduce((acc, item) => acc + (item.count || 0), 0);
    graphs.push({
        header: "Answered",
        totalCount: answeredTotal,
        dataArr: answered.map((item, index) => ({
            label: item.label || "",
            value: item.count || 0,
            color: item.color || this.getColor(index)
        }))
    });

    // Always show Not Answered graph, even if empty
    const notAnsweredTotal = notAnswered.reduce((acc, item) => acc + (item.count || 0), 0);
    graphs.push({
        header: "Not Answered",
        totalCount: notAnsweredTotal,
        dataArr: notAnswered.map((item, index) => ({
            label: item.label || "",
            value: item.count || 0,
            color: item.color || this.getColor(index + answered.length)
        }))
    });
    
    // Add Time On Calls card
    graphs.push({
        header: "Time On Calls",
        type: "stats",
        dataArr: [
            { label: "Total Time On Call", value: totalTimeOnCall, color: "#228799" },
            { label: "Average Call Duration", value: avgCallDuration, color: "#67BFE5" }
        ]
    });

    return graphs;
  };

  getColor = (index) => {
      const colors = ["#00A358", "#F59064", "#3953FB", "#228799", "#67BFE5", "#4288DD"];
      return colors[index % colors.length];
  }

  getOutcomeHeaders = () => {
    return [...dialerStoreData?.stageList]
      .filter(item => item?.displayEnabled)
      .map(item => ({
        name: item.displayName.split(" ").join("").toLowerCase(),
        displayName: item.displayName,
        enabled: true,
        isSort: false // Outcomes usually aren't sortable in this context or require backend support
      }));
  };

  render() {
    const analyticsData = this.constructAnalyticsData();
    const graphData = this.constructGraphCallsData();
    const outcomeHeaders = this.getOutcomeHeaders();
    
    // Construct allowed headers including outcomes
    const allowedHeaders = [
        "callsMadeCount",
        "callsLoggedCount",
        "callsViaSequenceCount",
        "callsAnswered",
        "callsNotAnswered",
        "totalTimeOnCall",
        "avgCallDurationInSecs",
        ...outcomeHeaders.map(h => h.name)
    ];

    return (
      <div className="reportsCalls">
        <div className="analyticsCardCont">
          {analyticsData.map((item, index) => (
            <AnalyticsCard key={index} {...item} />
          ))}
        </div>
        <div className="reportsGraphCont">
           <SequenceGraphComponent graphDataArr={graphData} />
        </div>
        <CallsAnalyticsSection />
        <ReportsActivity
          extraHeaders={outcomeHeaders}
          allowedHeaders={allowedHeaders}
        />
      </div>
    );
  }
}

export default ReportsCalls;
